import PaginationNav from "src/components/actionDashboard/paginationNav";
import { FC, Fragment, useEffect, useState } from "react";
import { sp_treatments_data, SpecialityPharmacyTypeProps } from "./types";
import { QueryParamsState } from "src/components/manufacturer/caseListing";
import PharmacyTableHeader from "src/components/actionDashboard/specialityPharmacy/pharamcayTableHeader";
import NoDataFound from "src/components/noDataFoundComponent";
import pharamacyTableBody from "src/components/actionDashboard/specialityPharmacy/pharamacyTableBody";
import PharamacyTableBody from "src/components/actionDashboard/specialityPharmacy/pharamacyTableBody";

const SpecialityPharmacy: FC<SpecialityPharmacyTypeProps> = ({ tableData, currentPage, onPageChange, refreshListing }) => {
  const [queryParam, setQueryParam] = useState<QueryParamsState>({
    direction: "desc",
    sort_by: "bi_case_id",
  });

  const [sortedData, setSortedData] = useState<sp_treatments_data[]>([]);

  // Initialize sortedData whenever new data comes from props
  useEffect(() => {
    if (tableData?.sp_treatments_data) {
      setSortedData([...tableData.sp_treatments_data]);
    }
  }, [tableData]);

  const changeIdOrder = (tableHeader: string) => {
    const newParams: QueryParamsState = {
      sort_by: tableHeader,
      direction:
        tableHeader === queryParam.sort_by
          ? queryParam.direction === "desc"
            ? "asc"
            : "desc"
          : "desc",
    };

    let sorted = [...(tableData?.sp_treatments_data || [])];

    switch (newParams.sort_by) {
      case "bi_case_id":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? Number(a.bi_case_id) - Number(b.bi_case_id)
            : Number(b.bi_case_id) - Number(a.bi_case_id)
        );
        break;

      case "patient_id":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? Number(a.patient_id) - Number(b.patient_id)
            : Number(b.patient_id) - Number(a.patient_id)
        );
        break;

      case "drug_name":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? (a.drug_name || "").localeCompare(b.drug_name || "")
            : (b.drug_name || "").localeCompare(a.drug_name || "")
        );
        break;

      case "patient_name":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? (a.patient_name || "").localeCompare(b.patient_name || "")
            : (b.patient_name || "").localeCompare(a.patient_name || "")
        );
        break;

       case "provider":
         sorted.sort((a, b) =>
           newParams.direction === "asc"
             ? (a.provider || "").localeCompare(b.provider || "")
             : (b.provider || "").localeCompare(a.provider || "")
         );
         break;

       case "pharmacy_sp_status":
         sorted.sort((a, b) =>
           newParams.direction === "asc"
             ? (a.pharmacy_sp_status || "").localeCompare(b.pharmacy_sp_status || "")
             : (b.pharmacy_sp_status || "").localeCompare(a.pharmacy_sp_status || "")
         );
         break;

      //  case "payer":
      //    sorted.sort((a, b) =>
      //      newParams.direction === "asc"
      //        ? (a.payer || "").localeCompare(b.payer || "")
      //        : (b.payer || "").localeCompare(a.payer || "")
      //    );
      //    break;

       case "sp_transferred_to":
         sorted.sort((a, b) =>
           newParams.direction === "asc"
             ? (a.sp_transferred_to || "").localeCompare(b.sp_transferred_to || "")
             : (b.sp_transferred_to || "").localeCompare(a.sp_transferred_to || "")
         );
         break;

       case "date_transferred":
         sorted.sort((a, b) =>
           newParams.direction === "asc"
             ? (a.date_transferred || "").localeCompare(b.date_transferred || "")
             : (b.date_transferred || "").localeCompare(a.date_transferred || "")
         );
         break;

       case "date_shipped":
         sorted.sort((a, b) =>
           newParams.direction === "asc"
             ? (a.date_shipped || "").localeCompare(b.date_shipped)
             : (b.date_shipped).localeCompare(a.date_shipped)
         );
         break;

      default:
        break;
    }
    setSortedData(sorted);
    setQueryParam(newParams);
  };
  return (
    <Fragment>

      <div className="table-responsive-sm table-responsive-md table-responsive-lg flex-fill">
        <table className="table table-striped table-sm m-0">
          <PharmacyTableHeader  queryParam={queryParam} changeIdOrder={changeIdOrder}/>
          {sortedData && sortedData.length > 0 ?
            <PharamacyTableBody
              data={sortedData}
              refreshListing={refreshListing}
            /> :
            <NoDataFound />
          }
        </table>
      </div>
      {tableData?.sp_treatments_data?.length > 0 && tableData.page_count > 1 && (
        <PaginationNav currentPage={currentPage} pageCount={tableData.page_count} onPageChange={onPageChange} />
      )}
    </Fragment>
  );
};

export default SpecialityPharmacy;
 